export const experienceData = [
    {
        id: 1,
        company: 'BITSCOL',
        jobtitle: 'React.js Developer',
        startYear: 'Oct 2022',
        endYear: 'Present'
    },
    /* {
        id: 2,
        company: 'BITSCOL',
        jobtitle: 'React.js Developer (Internship)',
        startYear: 'Oct 2022',
        endYear: 'Nov 2022'
    }, */
]